import React from "react";

const AnnouncementAll = () => {
  const announcements = [
    {
      title:
        "Tillionx Futures Will Launch USDⓈ-Margined XPLUSDT Perpetual Contract Pre-Market Trading (2025-08-22)",
      date: "2025-08-22",
    },
    {
      title:
        "Tillionx Futures Will Launch USDⓈ-Margined CUDISUSDT Perpetual Contract (2025-08-20)",
      date: "2025-08-20",
    },
    {
      title:
        "Sapien (SAPIEN) Will Be Available on Tillionx Alpha and Tillionx Futures (2025-08-20)",
      date: "2025-08-20",
    },
    {
      title:
        "Tillionx Will Add Plume (PLUME) on Earn, Buy Crypto, Convert & Margin",
      date: "2025-08-18",
    },
    {
      title:
        "Introducing Plume (PLUME) on Tillionx HODLer Airdrops! Earn PLUME With Retroactive BNB Simple Earn Subscriptions",
      date: "2025-08-18",
    },
    {
      title:
        "Notice on New Trading Pairs & Trading Bots Services on Tillionx Spot - 2025-08-19",
      date: "2025-08-18",
    },
  ];

  return (
    <div className="font-sans my-12">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-lg p-6 border border-gray-200">
          <nav className="flex items-center text-sm  mb-6">
            <span className="">Announcement</span>
            <span className="mx-2">›</span>
            <span className="font-semibold text-xs">
              New Cryptocurrency Listing
            </span>
          </nav>
          <h2 className="text-xl font-bold  mb-6">
            New Cryptocurrency Listing
          </h2>

          {announcements.map((announcement, index) => (
            <div
              key={index}
              className="py-4 border-b border-gray-200 last:border-b-0"
            >
              <h3 className="text-lg font-medium leading-relaxed hover:underline cursor-pointer">
                {announcement.title}
              </h3>
              <p className="text-sm text-gray-500 font-semibold mt-1">
                {announcement.date}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementAll;
